// extracted by mini-css-extract-plugin
export default {"otpInputError":"verifyAccount_otpInputError__q9upq","inputOtpStyle":"verifyAccount_inputOtpStyle__jEx43","g-recaptcha":"verifyAccount_g-recaptcha__1-o9-"};